import * as Yup from 'yup';
import { Copy } from '../copy/Copy';

export const SIGNUP_VALIDATION_SCHEMA = Yup.object({
  firstName: Yup.string().trim().required(Copy.generate('Errors.required')),
  lastName: Yup.string().trim().required(Copy.generate('Errors.required')),
  email: Yup.string()
    .email(Copy.generate('Errors.invalidEmail'))
    .required(Copy.generate('Errors.required')),
  password: Yup.string().required(Copy.generate('Errors.required')),
});

export const LOGIN_FORM_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
    .email(Copy.generate('Errors.invalidEmail'))
    .required(Copy.generate('Errors.required')),
  password: Yup.string().required(Copy.generate('Errors.required')),
});

export const VERIFY_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string().email(Copy.generate('Errors.invalidEmail')),
  confirmationCode: Yup.string()
    .min(6, 'Must be exactly 6 digits')
    .max(6, 'Must be exactly 6 digits')
    .required(Copy.generate('Errors.required')),
});

export const FORGOT_PASSWORD_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
    .email(Copy.generate('Errors.invalidEmail'))
    .required(Copy.generate('Errors.required')),
});

export const RESET_PASSWORD_VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
    .email(Copy.generate('Errors.invalidEmail'))
    .required(Copy.generate('Errors.required')),
  confirmationCode: Yup.string()
    .min(6, 'Must be exactly 6 digits')
    .max(6, 'Must be exactly 6 digits')
    .required(Copy.generate('Errors.required')),
  newPassword: Yup.string().required(Copy.generate('Errors.required')),
});
